/* Desert Supply theme scripts. No dependencies. */
(function () {
  'use strict';

  /* Mobile menu */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (!toggle) return;
    var menu = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!menu) return;
    var open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    menu.setAttribute('data-open', String(!open));
  });

  /* Quantity steppers (product + cart) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var min = parseInt(input.min || '0', 10);
    var next = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-qty-step'), 10));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    if (input.hasAttribute('data-autosubmit') && input.form) input.form.submit();
  });

  /* Product form: selling plans + variants drive the button label */
  function initProduct(root) {
    var form = root.querySelector('form[data-product-form]');
    if (!form) return;
    var submit = form.querySelector('[data-atc]');
    var submitLabel = form.querySelector('[data-atc-label]');
    var fine = root.querySelector('[data-plan-fine]');
    var priceEl = root.querySelector('.product__price [data-price]') || root.querySelector('span[data-price]');
    var sticky = document.querySelector('[data-sticky-atc="' + root.id + '"]');

    function selectedPlan() { return form.querySelector('input[name="selling_plan"]:checked'); }
    function selectedVariant() {
      return form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"][type="hidden"]');
    }

    function update() {
      var plan = selectedPlan();
      var variant = selectedVariant();
      var source = plan || variant;
      if (!source) return;
      var cta = source.getAttribute('data-cta');
      var available = !variant || variant.getAttribute('data-available') !== 'false';

      form.querySelectorAll('.plan').forEach(function (el) {
        var input = el.querySelector('input');
        el.classList.toggle('is-checked', !!(input && input.checked));
      });

      if (!available) cta = form.getAttribute('data-sold-out-label') || 'Sold out';
      if (submitLabel && cta) submitLabel.textContent = cta;
      if (submit) submit.disabled = !available;
      if (fine && source.getAttribute('data-fine')) fine.textContent = source.getAttribute('data-fine');
      if (priceEl && variant && variant.getAttribute('data-price')) priceEl.textContent = variant.getAttribute('data-price');

      if (sticky) {
        var n = sticky.querySelector('[data-sticky-name]');
        var p = sticky.querySelector('[data-sticky-price]');
        var b = sticky.querySelector('button');
        if (n) n.textContent = source.getAttribute('data-short-name') || '';
        if (p) p.textContent = source.getAttribute('data-short-price') || '';
        if (b) b.disabled = !available;
      }
    }

    form.addEventListener('change', update);
    update();

    /* Sticky add to cart (mobile) appears once the main button scrolls away */
    if (sticky && submit && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', past);
          sticky.setAttribute('aria-hidden', String(!past));
        });
      });
      io.observe(submit);
      var stickyBtn = sticky.querySelector('button');
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
      });
    }

    /* Gallery dots on mobile scroll */
    var gallery = root.querySelector('[data-gallery]');
    var dots = root.querySelectorAll('[data-gallery-dot]');
    if (gallery && dots.length) {
      gallery.addEventListener('scroll', function () {
        var i = Math.round(gallery.scrollLeft / Math.max(1, gallery.clientWidth));
        dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
      }, { passive: true });
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-product-root]').forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
